import request from '@/utils/request'

let CreditApi = {
  /*获取授信额度列表*/
  getCreditList(data, errorback) {
    return request._post('/shop/user.credit.credit/index', data, errorback);
  },

  /*添加授信额度*/
  addCredit(data, errorback) {
    return request._post('/shop/user.credit.credit/add', data, errorback);
  },

  /*删除授信额度*/
  delCredit(data, errorback) {
    return request._post('/shop/user.credit.credit/del', data, errorback);
  },

  /*授信额度-充值*/
  recharge(data, errorback) {
    return request._post('/shop/user.credit.credit/recharge', data, errorback);
  },

  /*获取授信明细列表*/
  getCreditLogList(data, errorback) {
    return request._post('/shop/user.credit.log/index', data, errorback);
  },

  /*获取设置数据*/
  getSetting(data) {
    return request._get('/shop/user.credit.setting/index', data);
  },
  
  /*保存设置数据*/
  saveSetting(data) {
    return request._post('/shop/user.credit.setting/index', data);
  },
}
export default CreditApi;



// WEBPACK FOOTER //
// ./src/api/credit.js